<div class="modal-footer justify-content-between">
  <button
    type="button"
    class="btn btn-default"
    [disabled]="cancelDisabled"
    (click)="onCancelClick.emit()"
    *ngIf="showCancelButton"
  >
    {{ cancelLabel }}
  </button>
  <button type="submit" class="btn btn-primary" *ngIf="showSaveButton" [disabled]="saveDisabled">
    {{ saveLabel }}
  </button>
</div>
